var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left d-flex flex-row"},[_c('div',[_vm._v("Организатор:")]),_c('div',[_c('div',{staticClass:"flex-column"},[_c('div',{staticClass:"pl-1"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"pl-1"},[_vm._v(" "+_vm._s(_vm.phone)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }